import React from 'react';

import { MediumCenteredContainer } from '@eika/engine-view';
import { Loader } from '@eika/loader';

interface Props {
    title: string;
}

const Loading = ({ title }: Props): JSX.Element => (
    <div className="text-center" style={{ marginTop: '150px' }}>
        <MediumCenteredContainer>
            <>
                <Loader />
                <br />
                {title}
            </>
        </MediumCenteredContainer>
    </div>
);

export default Loading;
